import React from "react";

const NotFound = () => {
  return (
    <div className="text-center mt-4">
      <img
      className="img-fluid w-50"
        src={
          "https://media.istockphoto.com/photos/oops-404-error-page-not-found-futuristic-robot-concept-with-wire-picture-id642741626?b=1&k=20&m=642741626&s=170667a&w=0&h=iHKsYzQsMphDz7pQ3zXqTlFygELP59eEwQnr03TUyJA="
        }
        alt=""
      />
    </div>
  );
};

export default NotFound;
